import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService, Message } from 'primeng/api';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { Usuario } from 'src/app/_models/usuario/usuario';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { EmpresaService } from 'src/app/_services/empresa.service';
import { Empresa } from 'src/app/_models/usuario/empresa';
import { AplicacaoService } from 'src/app/_services/aplicacao.service';
import { Aplicacao } from 'src/app/_models/usuario/aplicacao';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { PerfilService } from 'src/app/_services/perfil.service';
import { DominioService } from 'src/app/_services/dominio.service';
import { StatusUsuario } from 'src/app/_models/dominio/statusUsuario';
import { UsuarioResponse } from 'src/app/_models/response/usuarioResponse';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';
import { DatePipe } from '@angular/common';
import { Sacado } from 'src/app/_models/sacado/sacado';
import { SacadoService } from 'src/app/_services/sacado.service';


@Component({
  templateUrl: 'usuario.component.html',
  styleUrls: ['../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DatePipe]
})

export class UsuarioComponent implements OnInit {

  usuarioDialog: boolean;
  usuarios: Usuario[];
  usuarioReturn: Usuario;
  usuario: Usuario;
  selectedUsuarios: Usuario[];
  submitted: boolean;
  statusExibed: boolean;
  cols: any[];

   empresas: any = [];
   perfis: any = [];
   aplicacoes: any = [];
   statusUsuarios: any = [];

   empresa: Empresa;
   aplicacao: Aplicacao;
   perfil: Perfil;
   statusUsuario: StatusUsuario;

   username: string;
   dscEmail: string;
   password: string;

   msgs: Message[] = [];
   currentUsuario: Usuario;
   perfilUsuario: Perfil;
   permiteAcao: boolean;
   manterUsuario: string;

   header: any[];
   labelHeader: string;
   sacado: Sacado;
   sacados: Sacado[];
   filteredSacados: Sacado[];
   habilitaDocumento: boolean; 

  constructor(private usuarioService: UsuarioService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
              private empresaService: EmpresaService, private aplicacaoService: AplicacaoService,
              private perfilService: PerfilService, private dominioService: DominioService,
              private authenticationService: AuthenticationService, private bscobrancaTranslate: BscobrancaTranslate,
              private datepipe: DatePipe, private sacadoService: SacadoService) {
        this.manterUsuario = this.bscobrancaTranslate.getText('menu.manterUsuario');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterUsuario, routerLink: ['/usuario/usuario']  }
        ]);
    }

  ngOnInit(): void {
    this.currentUsuario = this.authenticationService.atualUserValue;
    this.permiteAcao = this.currentUsuario.permiteAcao;
    this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
    this.perfilUsuario = this.authenticationService.atualUserPerfilValue;
    if (this.perfilUsuario.nmePerfil === 'ADMCEDENTE' || this.perfilUsuario.nmePerfil === 'MNGCEDENTE' || this.perfilUsuario.nmePerfil === 'OPRCEDENTE') {
        this.sacadoService.getAllByCedente(this.currentUsuario.empresa.nroCNPJ).toPromise().then(data => this.sacados = data);
    }
    this.empresa = {};
    this.aplicacao = {};
    this.perfil = {};
    this.statusUsuario = {};
    this.cols = [
            { field: 'nmeUsuario', header: 'Nome Usuario' },
            { field: 'username', header: 'Username' },
            { field: 'email', header: 'E-mail' },
            { field: 'empresa', header: 'Empresa' },
            { field: 'aplicacao', header: 'Aplicacao' },
            { field: 'perfil', header: 'Perfil' },
            { field: 'dtaCriacao', header: 'Data de Criacao' },
            { field: 'status', header: 'Status' }
        ];

    this.header = ['Nome Usuario', 'E-mail', 'Empresa', 'Aplicacao', 'Perfil', 'Data de Criacao', 'Status'];
  }

  filterSacados(event: { query: any; }) {
        const filtered: any[] = [];
        const query = event.query;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.sacados.length; i++) {
            const sacado = this.sacados[i];
            if (sacado.nmeSacado.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                filtered.push(sacado);
            }
        }
        this.filteredSacados = filtered;
    }

  openNew() {
       this.empresaService.getEmpresasPorUsuario(this.currentUsuario).toPromise().then(data => this.empresas = data);
       this.perfilService.getAllPorPerfil(this.perfilUsuario.nmePerfil).toPromise().then(data => this.perfis = data);
       this.dominioService.getAllStatusUsuario().toPromise().then(data => this.statusUsuarios = data);
       if (this.perfilUsuario.nmePerfil === 'ADMCEDENTE' || this.perfilUsuario.nmePerfil === 'MNGCEDENTE' 
            || this.perfilUsuario.nmePerfil === 'OPRCEDENTE') {
            this.sacadoService.getAllByCedente(this.currentUsuario.empresa.nroCNPJ).toPromise().then(data => this.sacados = data);
       }
       this.usuario = {};
       this.usuarioReturn = {};
       this.usuario.dscEmail = null;
       this.usuario.username = null;
       this.usuario.password = null;
       this.usuario.nmeUsuario = null;
       this.usuario.statusUsuario = {};
       this.statusExibed = false;

       this.empresa = {};
       this.aplicacao = {};
       this.perfil = {};
       this.statusUsuario = {};

       this.submitted = false;
       this.usuarioDialog = true;
  }

  getAplicacaoEmpresa() {
         this.aplicacaoService.getAplicaoPorEmpresa(this.empresa).toPromise().then(data => this.aplicacoes = data);
  }

  getPerfilDocumento() {
    console.log(this.perfil);
    if (this.perfil.codPerfil === 7) {
        this.habilitaDocumento = true;
    } else {
        this.habilitaDocumento = false;
    }
  }

  deleteSelectedBancos() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.usuarios = this.usuarios.filter(val => !this.selectedUsuarios.includes(val));
                this.selectedUsuarios = null;
                this.messageService.add({severity: 'success', summary: 'Successful', detail: 'Banco Excluido', life: 3000});
            }
        });
    }

    editUsuario(usuario: Usuario) {
        this.messageService.clear();
        this.usuario = {...usuario};
        this.aplicacao = usuario.aplicacao;
        this.empresa =  usuario.empresa;
        this.perfil = usuario.perfil;
        this.statusUsuario = usuario.statusUsuario;
        this.empresaService.getEmpresasPorUsuario(this.currentUsuario).toPromise().then(data => this.empresas = data);
        this.perfilService.getAllPorPerfil(this.perfilUsuario.nmePerfil).toPromise().then(data => this.perfis = data);
        this.aplicacaoService.getAplicaoPorEmpresa(this.empresa).toPromise().then(data => this.aplicacoes = data);
        this.dominioService.getAllStatusUsuario().toPromise().then(data => this.statusUsuarios = data);
        this.usuarioDialog = true;
        this.statusExibed = true;
        console.log(usuario.perfil.nmePerfil);
        if (usuario.perfil.nmePerfil === 'CONSSACADO') {
            this.habilitaDocumento = true;
        }
    }

    pesquisaSacado() {
        if (this.usuario.nroCpf && this.usuario.nroCpf !== '' && this.usuario.nroCpf !== undefined) {
            this.sacadoService.getSacadoPorDocumento(this.usuario.nroCpf).subscribe(
                    (sacado: Sacado) => {
                        if (sacado && sacado.nmeSacado !== '') {
                            this.usuario.nmeUsuario = sacado.nmeSacado;
                        } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.usuario-010'),
                                            life: 3000});
                        }
                        this.sacado = sacado;
                    });
        } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.usuario-011'),
                                life: 3000});
        }
    }

    sendUpdatePassword(usuario: Usuario) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.usuario-001'),
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                 this.usuarioService.reenvioSenha(usuario).subscribe(
                    (usuarioResponse: UsuarioResponse) => {
                        if (usuarioResponse) {
                            if (usuarioResponse.codigo === 0) {
                                this.messageService.add({severity: 'success', summary: 'Successful',
                                detail: this.bscobrancaTranslate.getText('mensagens.usuario-002'), life: 3000});
                            } else {
                                this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                                this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                        life: 3000});
                            }
                        } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                        life: 3000});
                        }
            });
            }
        });
    }

    deleteUsuario(usuario: Usuario) {

        let mensagem: string;
        let returnMessage: string;
        if (usuario.statusUsuario.nomStatusUsuario === 'Ativo') {
            mensagem = this.bscobrancaTranslate.getText('mensagens.usuario-007') + usuario.nmeUsuario + '?';
            returnMessage = this.bscobrancaTranslate.getText('mensagens.usuario-003');
        } else {
            mensagem = this.bscobrancaTranslate.getText('mensagens.usuario-008') + usuario.nmeUsuario + '?';
            returnMessage = this.bscobrancaTranslate.getText('mensagens.usuario-009');
        }
        this.confirmationService.confirm({
            message: mensagem,
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.usuarioService.deletar(usuario).subscribe(
                (usuarioResponse: UsuarioResponse) => {
                     if (usuarioResponse) {
                         if (usuarioResponse.codigo === 0) {
                            this.messageService.add({severity: 'success', summary: 'Successful', detail: returnMessage,
                            life: 3000});
                            this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                         } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem, life: 3000});
                         }
                     } else {
                        this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                        this.messageService.add({severity: 'error', summary: 'Error',
                            detail: this.bscobrancaTranslate.getText('mensagens.usuario-004'), life: 3000});
                     }
                });
            }
        });
    }

    hideDialog() {
        this.usuarioDialog = false;
        this.submitted = false;
        this.habilitaDocumento = false;
    }

    saveBanco() {
        this.submitted = true;
        this.messageService.clear();
        if (this.usuario.username !== '') {
            if (this.usuario.codUsuario != null) {
                this.usuario.empresa = this.empresa;
                this.usuario.perfil = this.perfil;
                this.usuario.aplicacao = this.aplicacao;
                const messagem = this.validateUser(this.usuario);
                if (messagem === '') {
                    this.usuarioService.atualizar(this.usuario).subscribe(
                    (usuarioResponse: UsuarioResponse) => {
                        if (usuarioResponse) {
                            if (usuarioResponse.codigo === 0) {
                                this.messageService.add({severity: 'success', summary: 'Successful',
                                detail: this.bscobrancaTranslate.getText('mensagens.usuario-005'), life: 3000});
                                this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                                this.usuarios = [...this.usuarios];
                                this.usuarioDialog = false;
                                if (this.usuario.perfil.nmePerfil === 'CONSSACADO') {
                                    this.habilitaDocumento = false;
                                }
                                this.usuario = {};
                            } else {
                                this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                life: 3000});
                                this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                                if (this.usuario.perfil.nmePerfil !== 'CONSSACADO') {
                                    this.habilitaDocumento = false;
                                }
                            }
                        } else {
                             this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                  life: 3000});
                        }
                    });
                } else {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: messagem,
                                  life: 3000});
                }
            }
            else {
                this.usuario.empresa = this.empresa;
                this.usuario.perfil = this.perfil;
                this.usuario.aplicacao = this.aplicacao;
                this.usuario.primeiroAcesso = true;
                const messagem = this.validateUser(this.usuario);
                if (messagem === '') {
                this.usuarioService.addUsuario(this.usuario).subscribe(
                     (usuarioResponse: UsuarioResponse) => {
                         if (usuarioResponse) {
                            if (usuarioResponse.codigo === 0) {
                                this.messageService.add({severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.usuario-006'),
                                life: 3000});
                                this.usuarioService.getAll(this.currentUsuario).toPromise().then(data => this.usuarios = data);
                                this.usuarios = [...this.usuarios];
                                this.usuarioDialog = false;
                                if (this.usuario.perfil.nmePerfil === 'CONSSACADO') {
                                    this.habilitaDocumento = false;
                                }
                                this.usuario = {};
                            } else {
                                  this.messageService.add({severity: 'error', summary: 'Error', detail: usuarioResponse.mensagem,
                                  life: 3000});
                            }
                         } else {
                            this.messageService.add({severity: 'error', summary: 'Error', detail: messagem,
                                  life: 3000});
                         }
                     });
                    } else {
                        this.messageService.add({severity: 'error', summary: 'Error', detail: messagem,
                                  life: 3000});
                    }
            }
        }
    }

    validateUser(usuario: Usuario) {
        if (usuario.perfil.codPerfil === 7
            && (usuario.nmeUsuario === '' || usuario.nmeUsuario === null || usuario.nmeUsuario === undefined)) {
            return this.bscobrancaTranslate.getText('mensagens.usuario-012');
        }
        return '';
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.usuarios.length; i++) {
            if (this.usuarios[i].codUsuario === id) {
                index = i;
                break;
            }
        }
        return index;
    }

    downloadFile(filename= 'usuario') {
        const csvData = this.ConvertToCSV(this.header);
        console.log(csvData);
        const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        const dwldLink = document.createElement('a');
        const url = URL.createObjectURL(blob);
        const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
        if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
            dwldLink.setAttribute('target', '_blank');
        }
        dwldLink.setAttribute('href', url);
        dwldLink.setAttribute('download', filename + '.csv');
        dwldLink.style.visibility = 'hidden';
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    ConvertToCSV(headerList: any[]) {
         let str = '';
         let row = 'No;';
         // tslint:disable-next-line: forin
         for (const index in headerList) {
             row += headerList[index] + ';';
         }
         row = row.slice(0, -1);
         str += row + '\r\n';
         for (let i = 0; i < this.usuarios.length; i++) {
             const usu = this.usuarios[i];
             let line = (i + 1) + ';';
             line += usu.nmeUsuario + ';';
             line += usu.dscEmail + ';';
             line += usu.empresa.nmeEmpresa + ';';
             line += usu.aplicacao.nmeAplicacao + ';';
             line += usu.perfil.dscPerfil + ';';
             line += this.datepipe.transform(usu.dtaCadastro, 'dd/MM/yyyy') + ';';
             line += usu.statusUsuario.nomStatusUsuario + ';';
             str += line + '\r\n';
         }
         return str;
     }


    isCPF(documento: string): boolean{
        return documento == null ? true : documento.length < 12 ? true : false;
     }

     formatar_cnpj(v: string){
        v = v.replace(/[^0-9A-Za-z]/g, '').toUpperCase().substring(0, 14);   // CNPJ alfanumerico: mantem 0-9 e A-Z                          //Remove tudo o que n�o � d�gito
        v = v.replace(/^([0-9A-Z]{2})([0-9A-Z])/, '$1.$2');            //Coloca ponto entre o segundo e o terceiro d�gitos
        v = v.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, '$1.$2.$3'); //Coloca ponto entre o quinto e o sexto d�gitos
        v = v.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, '.$1/$2');           //Coloca uma barra entre o oitavo e o nono d�gitos
        v = v.replace(/([0-9A-Z]{4})([0-9A-Z])/, '$1-$2');              //Coloca um h�fen depois do bloco de quatro d�gitos
        return v;
    }

    formatar_cpf(v: string){
        v = v.replace(/\D/g, '');                    //Remove tudo o que n�o � d�gito
        v = v.replace(/(\d{3})(\d)/,"$1.$2");;       //Coloca um ponto entre o terceiro e o quarto d�gitos
        v = v.replace(/(\d{3})(\d)/,"$1.$2");       //Coloca um ponto entre o terceiro e o quarto d�gitos
                                                //de novo (para o segundo bloco de n�meros)
        v = v.replace(/(\d{3})(\d{1,2})$/,"$1-$2"); //Coloca um h�fen entre o terceiro e o quarto d�gitos
        return v;
    }

    formatarDocumento(documento: string) {
        if (documento && documento !== '') {
            if (this.isCPF(documento)) {
                return this.formatar_cpf(documento);
            } else {
                return this.formatar_cnpj(documento);
            }
        }
    }

}

